module.exports = __webpack_public_path__ + "static/media/1_hall_outdoors_front.1d598c6a.jpg";